import { getBackendGraphqlApiConfig } from './get-backend-graphql-config';
import { makeApolloClient } from './create-apollo-client';

import { getRuntimeEnvironment } from '@/environment/get-runtime-environment';

export const makeServerSideApolloClient = () => {
  const env = getRuntimeEnvironment(process.env.FRONTEND_BASE_URL);

  const config = getBackendGraphqlApiConfig(env);

  return makeApolloClient(config);
};
